import { useState } from "react";
import { faqList } from "@/mocks/manga";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };

  return (
    <section id="faq" className="py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-800">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">
            关于同步与阅读，你想问的都在这里
          </h2>
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
        />

        <div className="mt-10 space-y-3">
          {faqList.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.id}
                className="overflow-hidden rounded-xl border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="font-medium text-foreground-950">{item.question}</span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-transform ${
                      isOpen
                        ? "rotate-45 bg-primary-500 text-background-50"
                        : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-700">{item.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}